import { render, staticRenderFns } from "./OtherOfficeConnectionListTab.vue?vue&type=template&id=16f70e1e&scoped=true&lang=pug"
import script from "./OtherOfficeConnectionListTab.vue?vue&type=script&lang=ts"
export * from "./OtherOfficeConnectionListTab.vue?vue&type=script&lang=ts"
import style0 from "./OtherOfficeConnectionListTab.vue?vue&type=style&index=0&id=16f70e1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f70e1e",
  null
  
)

export default component.exports